// GA4 Tracking — zentrale Hilfsfunktion
// Measurement ID wird in index.html als G-XXXXXXXX Platzhalter gesetzt.
// Vor Ad-Launch durch echte Google Analytics Property-ID ersetzen.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function track(
  event: string,
  params?: Record<string, string | number>
): void {
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params ?? {});
  }
}
